import script from "./PostShow.vue?vue&type=script&setup=true&lang=js"
export * from "./PostShow.vue?vue&type=script&setup=true&lang=js"

import "./PostShow.vue?vue&type=style&index=0&id=4259b14a&lang=css"

const __exports__ = script;

export default __exports__